<template>
  <div class="donation">
    <h1>Include a donation to the Soo Bahk Do Institute:</h1>

    <p>If you are able, non tax-deductible donations are appreciated.</p>
    <div class="uk-flex uk-flex-center uk-flex-middle">
      <label class="donation__label"><input
        v-model="donate"
        type="checkbox"
      > Yes, I would like to include a donation for</label>
      <div class="uk-form">
        <div class="uk-form-icon">
          <span class="uk-icon-dollar" /> <input
            v-model="donationAmount"
            type="number"
            placeholder="0.00"
            step="1"
            @input="updateDonation"
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import {Component, Vue} from "vue-property-decorator";
import CartItemModel, {
  CART_ITEM_DONATION,
  create as createItem
} from "../../../models/CartItemModel";

@Component
export default class Donation extends Vue {

  amount!: number;

  data(): any {
    return {
      amount: 0
    }
  }

  created(): void {
    if (this.donationItem) {
      this.amount = this.donationItem.data.value;
    }
  }

  get donationAmount(): string {
    return '' + this.amount;
  }

  set donationAmount(n: string) {
    this.amount = parseFloat(parseFloat(n).toFixed(2));
  }

  get donationItem(): CartItemModel | null {
    return this.$store.getters['events/cart/bySKU'](CART_ITEM_DONATION);
  }

  get donate(): boolean {
    return this.donationItem ? true : false;
  }

  set donate(v: boolean) {
    this.$store.dispatch('events/cart/removeItem', CART_ITEM_DONATION);

    const amount = this.amount;
    if (v && amount > 0) {
      const item = createItem();
      item.data.sku = CART_ITEM_DONATION;
      item.data.value = amount;
      item.data.quantity = 1;
      this.$store.dispatch('events/cart/addItem', item);
    }
  }

  updateDonation(): void {
    this.donate = false;
    this.donate = true;
  }
}
</script>

<style scoped>
.donation {
  text-align: center;
}
.donation__label {
  display: flex;
}
.donation__label input {
  margin-right: 0.5em;
}
.donation h1 {
  font-size: 1.2em;
  margin-bottom: 0.5em;
}
.donation .uk-form {
  margin-left: 0.5em;
  width: 100px;
}
</style>
